import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { TreeContext } from "pages/Editor";
import { useAttribute } from "lib/hooks";

function Map({ style }, ref) {
  const { publish, iframe } = useContext(TreeContext);
  const [loaded, setLoaded] = useState(false);
  const map = useRef();
  const [center] = useAttribute("center");
  const [zoom] = useAttribute("zoom");
  useEffect(() => {
    if (iframe.current) {
      const w = iframe.current.contentWindow;
      if (w.google || loaded) {
        map.current = new w.google.maps.Map(ref.current, {
          zoom: 4,
          center: { lat: -25.344, lng: 131.036 },
        });
      } else {
        const key = "AIzaSyBEcG0zGg7TAycmrIhQ2W7RN3-BGw4ble0";
        const script =
          "https://maps.googleapis.com/maps/api/js?key=" +
          key +
          "&callback=initMap";
        const s = w.document.createElement("script");
        s.src = script;
        w.document.body.appendChild(s);
        w.initMap = function () {
          setLoaded(true);
        };
      }
    }
  }, [publish, ref, iframe, loaded]);
  useEffect(() => {
    if (center) {
      const [lat, lng] = center.split(",").map((f) => parseFloat(f));
      map.current.setCenter({ lat, lng });
    }
  }, [center]);
  useEffect(() => {
    if (zoom) {
      map.current.setZoom(parseInt(zoom, 10));
    }
  }, [zoom]);
  const computedStyle = { ...style };
  if (!style.width) computedStyle.width = 300;
  if (!style.height) computedStyle.height = 300;
  return <div {...{ ref, style: computedStyle }}></div>;
}

export default forwardRef(Map);
